import { aiUrl } from './apiProxy';

export default function ai() {
	// handle uploading photo
	let kmImageUpload = document.querySelector('#kmImageUpload');
	if (!kmImageUpload) return;

	let kmModal = document.querySelector('.c-modal--km');

	let applyKmNumber = kmModal.querySelector('.js-apply-km-number-to-field');

	if (applyKmNumber) {
		applyKmNumber.addEventListener('click', function () {
			let kmNumberValue = kmModal.querySelector('#kmNumber').innerHTML;
			let kmNumberHolder = document.querySelector('#mileage');
			kmNumberHolder.value = kmNumberValue;
			closekmModal();
		});
	}

	let openkmModalTriggers = document.querySelectorAll('.js-open-km-modal');
	let closekmModalTriggers = document.querySelectorAll('.js-close-km-modal');

	if (openkmModalTriggers.length > 0) {
		openkmModalTriggers.forEach((openKm) => {
			openKm.addEventListener('click', function () {
				resetModal();
				openkmModal();
			});
		});
	}

	if (closekmModalTriggers.length > 0) {
		closekmModalTriggers.forEach((closeKm) => {
			closeKm.addEventListener('click', function () {
				resetModal();
				closekmModal();
			});
		});
	}

	let steps = {
		info: 'c-modal__upload--info',
		start: 'c-modal__upload--start',
		verify: 'c-modal__upload--verify',
		uploading: 'c-modal__upload--uploading',
		services: 'c-modal__upload--services',
	};

	function resetModal() {
		let uploaderError = kmModal.querySelector('.c-modal__upload-status--error');
		if (uploaderError) {
			uploaderError.classList.remove('active');
		}

		let uploaderFailed = kmModal.querySelector('.c-modal__uploader.failed');
		if (uploaderFailed) {
			uploaderFailed.classList.remove('failed');
		}

		// Progress bar width to 1%
		let kmImageUploadProgress = kmModal.querySelector('#kmImageUploadProgress');
		if (kmImageUploadProgress) {
			kmImageUploadProgress.style.width = '1%';
		}

		let errorButtons = kmModal.querySelectorAll('.c-modal__upload-buttons--error.active');
		if (errorButtons.length > 0) {
			errorButtons.forEach(button => button.classList.remove('active'));
		}

		let uploadSuccess = kmModal.querySelector('.c-modal__upload-status--success');
		if (uploadSuccess) {
			uploadSuccess.classList.remove('active');
		}
		let buttonSuccess = kmModal.querySelector('.c-modal__upload-buttons--success');
		if (buttonSuccess) {
			buttonSuccess.classList.remove('active');
		}

		let uploadStart = kmModal.querySelector('.c-modal__upload--start');
		if (uploadStart) {
			uploadStart.classList.remove('active');
		}
		let uploadStartUploading = kmModal.querySelector('.c-modal__upload-status--uploading');
		if (uploadStartUploading) {
			uploadStartUploading.classList.add('active');
		}

		let kmStart = kmModal.querySelector('.c-modal__upload--info');
		if (kmStart) {
			kmStart.classList.add('active');
		}

		let uploader = kmModal.querySelector('.c-modal__uploader');
		if (uploader) {
			uploader.classList.remove('active');
		}
		let uploading = kmModal.querySelector('.c-modal__upload--uploading');
		if (uploading) {
			uploading.classList.remove('active');
		}

		// Reset file input
		let kmImageUpload = kmModal.querySelector('#kmImageUpload');
		if (kmImageUpload) {
			kmImageUpload.value = '';
		}

		// Remove image preview
		let imagePreview = kmModal.querySelector('#kmImagePreview');
		if (imagePreview) {
			imagePreview.innerHTML = '';
		}

		// Reset file name and size display
		let uploadFileNameDashboard = kmModal.querySelector('#uploadFileNameDashboard');
		if (uploadFileNameDashboard) {
			uploadFileNameDashboard.innerHTML = '';
		}

		let uploadFileSizeDashboard = kmModal.querySelector('#uploadFileSizeDashboard');
		if (uploadFileSizeDashboard) {
			uploadFileSizeDashboard.innerHTML = '';
		}
	}

	function simulateRandomUpload() {
		// Add width to #kmImageUploadProgress to go to 96%
		let kmImageUploadProgress = kmModal.querySelector('#kmImageUploadProgress');
		let progress = 0; // Start from 0%
		const maxProgress = 96; // Maximum progress before stopping

		const uploadInterval = setInterval(() => {
			// Randomly increase progress by 1% to 5%
			const randomIncrease = Math.floor(Math.random() * 5) + 1;
			progress += randomIncrease;

			if (progress > maxProgress) {
				progress = maxProgress; // Ensure progress does not exceed maxProgress
			}

			kmImageUploadProgress.style.width = `${progress}%`;

			// Check if we've reached or exceeded the stopping point
			if (progress >= maxProgress) {
				clearInterval(uploadInterval); // Stop the simulated upload
			}
		}, 200); // Adjust time interval as needed
	}

	function openkmModal() {
		// add ai-modal-open on body
		document.body.classList.add('ai-modal-open-km');
	}

	function closekmModal() {
		document.body.classList.remove('ai-modal-open-km');
		resetModal();
	}

	(function () {
		let copyText = kmModal.querySelector('.js-copy-value');
		if (copyText) {
			copyText.addEventListener('click', function () {
				let text = copyText.querySelector('p').innerText;
				navigator.clipboard.writeText(text);
				copyText.classList.add('copied');
			});
		}
	})();

	function sendImageForVerification() {
		// Key added server side by the site's proxy.
		const endpoint = aiUrl('read');

		// Get the image element
		const imgElement = document.querySelector('#kmImagePreview img');
		const imgSrc = imgElement.src;

		// Function to convert base64 to Blob
		function base64ToBlob(base64, type = 'application/octet-stream') {
			const binaryString = window.atob(base64.split(',')[1]);
			const len = binaryString.length;
			const bytes = new Uint8Array(len);
			for (let i = 0; i < len; i++) {
				bytes[i] = binaryString.charCodeAt(i);
			}
			return new Blob([bytes], { type });
		}

		// Convert base64 image src to Blob
		const blob = base64ToBlob(imgSrc, 'image/jpeg');

		// Send the Blob to the prediction endpoint
		fetch(endpoint, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/octet-stream',
			},
			body: blob,
		})
			.then((response) => response.json())
			.then((data) => {
				kmModal.querySelector('.c-modal__uploader').classList.add('active');
				console.log('OCR Results:', data);

				if (data.code === 'BadRequestImageFormat') {
					alert('Image format is not accepted. Please upload a valid image.');
				}

				function extractOdometerReading(ocrData) {
					const lines = ocrData.blocks[0].lines;
					const odometerReading = lines
						.map((line) => line.text)
						.filter((text) => /^[0-9]+$/.test(text)) // Filter for purely numeric text
						.map((text) => parseInt(text, 10)) // Convert to integers
						.filter((num) => num > 999) // Assuming the odometer value will be a large number
						.sort((a, b) => b - a); // Sort in descending order

					return odometerReading.length ? odometerReading[0] : null;
				}
				const odometerMileage = extractOdometerReading(data.readResult);


				if (odometerMileage) {
					kmModal.querySelector('.c-modal__upload-status--uploading').classList.remove('active');
					kmModal.querySelector('.c-modal__upload-status--success').classList.add('active');
					kmModal.querySelector('.c-modal__upload-buttons--success').classList.add('active');

					// Add km number to the modal
					let kmNumberHolder = kmModal.querySelector('#kmNumber');
					kmNumberHolder.innerHTML = odometerMileage;
				} else {
					kmModal.querySelector('.c-modal__upload-status--uploading').classList.remove('active');
					kmModal.querySelector('.c-modal__upload-status--error').classList.add('active');
					kmModal.querySelector('.c-modal__upload-buttons--error').classList.add('active');
					kmModal.querySelector('.c-modal__uploader').classList.add('failed');
					kmModal.querySelector('.c-modal__uploader').classList.remove('active');
				}
			})
			.catch((error) => {
				console.error('Error:', error);
			});
	}

	// Function for showing/hiding steps where active one gets removed and the next one is shown
	function showStep(step) {
		let activeStep = kmModal.querySelector('.c-modal__upload.active');
		activeStep.classList.remove('active');
		kmModal.querySelector('.' + step).classList.add('active');
	}

	const goToStartButtons = kmModal.querySelectorAll('.js-go-to-start');

	if (goToStartButtons.length > 0) {
		goToStartButtons.forEach((goToStart) => {
			goToStart.addEventListener('click', function () {
				showStep(steps.start);
				resetModal();
			});
		});
	}

	let goToUploading = kmModal.querySelector('.js-go-to-uploading');
	if (goToUploading) {
		goToUploading.addEventListener('click', function () {
			showStep(steps.uploading);

			sendImageForVerification();
		});
	}

	let goToServices = kmModal.querySelector('.js-go-to-service-selector');
	if (goToServices) {
		goToServices.addEventListener('click', function () {
			showStep(steps.services);
		});
	}

	let closekmModalClasses = kmModal.querySelectorAll('.js-close-modal');
	if (closekmModalClasses) {
		closekmModalClasses.forEach(function (trigger) {
			trigger.addEventListener('click', function () {
				closekmModal();
			});
		});
	}

	// Press ESC to close modal
	document.addEventListener('keydown', function (e) {
		if (e.key === 'Escape') {
			closekmModal();
		}
	});

	let closekmModalTrigger = kmModal.querySelector('.js-close-modal-trigger-icon-select');
	if (closekmModalTrigger) {
		closekmModalTrigger.addEventListener('click', function () {
			let iconSelectButton = kmModal.querySelector('.js-qt-confirm-icon-select');
			iconSelectButton.click();
			closekmModal();
		});
	}

	let openAiModalTrigger = kmModal.querySelector('.js-open-ai-km-modal');
	if (openAiModalTrigger) {
		openAiModalTrigger.addEventListener('click', function () {
			openkmModal();
			showStep(steps.start);
		});
	}
	let goToStart = kmModal.querySelector('.js-go-to-start');
	if (goToStart) {
		goToStart.addEventListener('click', function () {
			console.log('Go to start');
			showStep(steps.start);
		});
	}

	kmImageUpload.addEventListener('change', function (e) {
		let file = e.target.files[0];
		let formData = new FormData();
		formData.append('file', file);

		const reader = new FileReader();
		reader.onload = function (e) {
			const imagePreview = kmModal.querySelector('#kmImagePreview');
			imagePreview.innerHTML = '<img src="' + e.target.result + '" alt="Image preview" style="max-width: 100%; height: auto;"/>';

			// Get file name and size
			let fileName = file.name;
			let fileSize = file.size;

			// Add file name to #uploadFileName
			let uploadFileName = kmModal.querySelector('#uploadFileNameKm');
			uploadFileName.innerHTML = fileName;

			// Add file size to #uploadFileSize
			let uploadFileSize = kmModal.querySelector('#uploadFileSizeKm');
			//Convert bytes to KB
			let fileSizeInKB = fileSize / 1024;
			uploadFileSize.innerHTML = fileSizeInKB.toFixed(0) + ' KB';

			// Show the next step
			showStep(steps.verify);
			simulateRandomUpload();
		};
		reader.readAsDataURL(file);
	});
}
